<template>
  <div>
    <div v-if="customer.orders.length > 0">
      <template v-for="(order, index) in customer.orders">
        <div v-if="customer.orders" :key="index">
          <order-view
            v-model="customer.orders[index]"
            @click="toggleOrder(index)"
          >
          </order-view>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderTab',
  props: {
    customer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentOrderIndex: null,
    }
  },
  mounted() {
    this.refreshCustomerOrders()
  },
  methods: {
    refreshCustomerOrders() {
      return axios
        .get(`/customer/${this.customer.id}/orders`)
        .then((response) => {
          this.$store.dispatch('setCurrentCustomerOrders', response.data.orders)
        })
    },
    toggleOrder(index) {
      if (index === this.currentOrderIndex) {
        this.currentOrderIndex = null
        return
      }
      this.currentOrderIndex = index
    },
  }
}
</script>


// WEBPACK FOOTER //
// OrderTab.vue?1a92b6e8